// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateTestamentaryEntityMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateTestamentaryEntityInput;
}>;


export type CreateTestamentaryEntityMutation = { __typename?: 'Mutation', createTestamentaryEntity: { __typename?: 'TestamentaryEntity', id: string, displayName: string } };

export type DuplicateTestamentaryEntityMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DuplicateTestamentaryEntityMutation = { __typename?: 'Mutation', duplicateTestamentaryEntity: { __typename?: 'TestamentaryEntity', id: string } };

export const Operations = {
  Mutation: {
    CreateTestamentaryEntity: 'CreateTestamentaryEntity' as const,
    DuplicateTestamentaryEntity: 'DuplicateTestamentaryEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateTestamentaryEntityDocument = gql`
    mutation CreateTestamentaryEntity($input: AugmentedCreateTestamentaryEntityInput!) {
  createTestamentaryEntity(input: $input) {
    id
    displayName
  }
}
    `;
export type CreateTestamentaryEntityMutationFn = Apollo.MutationFunction<CreateTestamentaryEntityMutation, CreateTestamentaryEntityMutationVariables>;

/**
 * __useCreateTestamentaryEntityMutation__
 *
 * To run a mutation, you first call `useCreateTestamentaryEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestamentaryEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestamentaryEntityMutation, { data, loading, error }] = useCreateTestamentaryEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestamentaryEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestamentaryEntityMutation, CreateTestamentaryEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestamentaryEntityMutation, CreateTestamentaryEntityMutationVariables>(CreateTestamentaryEntityDocument, options);
      }
export type CreateTestamentaryEntityMutationHookResult = ReturnType<typeof useCreateTestamentaryEntityMutation>;
export type CreateTestamentaryEntityMutationResult = Apollo.MutationResult<CreateTestamentaryEntityMutation>;
export type CreateTestamentaryEntityMutationOptions = Apollo.BaseMutationOptions<CreateTestamentaryEntityMutation, CreateTestamentaryEntityMutationVariables>;
export const DuplicateTestamentaryEntityDocument = gql`
    mutation DuplicateTestamentaryEntity($id: ID!) {
  duplicateTestamentaryEntity(id: $id) {
    id
  }
}
    `;
export type DuplicateTestamentaryEntityMutationFn = Apollo.MutationFunction<DuplicateTestamentaryEntityMutation, DuplicateTestamentaryEntityMutationVariables>;

/**
 * __useDuplicateTestamentaryEntityMutation__
 *
 * To run a mutation, you first call `useDuplicateTestamentaryEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTestamentaryEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTestamentaryEntityMutation, { data, loading, error }] = useDuplicateTestamentaryEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateTestamentaryEntityMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateTestamentaryEntityMutation, DuplicateTestamentaryEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateTestamentaryEntityMutation, DuplicateTestamentaryEntityMutationVariables>(DuplicateTestamentaryEntityDocument, options);
      }
export type DuplicateTestamentaryEntityMutationHookResult = ReturnType<typeof useDuplicateTestamentaryEntityMutation>;
export type DuplicateTestamentaryEntityMutationResult = Apollo.MutationResult<DuplicateTestamentaryEntityMutation>;
export type DuplicateTestamentaryEntityMutationOptions = Apollo.BaseMutationOptions<DuplicateTestamentaryEntityMutation, DuplicateTestamentaryEntityMutationVariables>;